// extracted by mini-css-extract-plugin
export default {"root":"Amount_root__c3CUT","items":"Amount_items__EeDaS","caption":"Amount_caption__YpyM3","name":"Amount_name__aHDtb","total":"Amount_total__jM205"};